import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/totalRevenueSagas";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import { Tooltip } from "react-tooltip";

export const RollingViewToggle = () => {
  const dispatch = useDispatch();
  const rolling_view = useSelector((state) => state.totalRevenue.rolling_view);
  const tooltipId = "rolling-view-tooltip";

  return (
    <>
      <div
        className="rolling-view"
        data-tooltip-id={tooltipId}
        data-tooltip-content="This toggle will switch the chart from a Rolling 12-month view to Year-to-Date (YTD) view"
      >
        <p>Rolling View</p>
        <ToggleableButton
          isActive={rolling_view}
          isRadio
          title="rolling_view"
          onClick={(data) => dispatch(actionCreators.updateRollingView(data))}
        />
      </div>

      <Tooltip id={tooltipId} float />
    </>
  );
};
